<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-newspaper-variant-outline
          </v-icon>
          トピック表示
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForms.content"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="内容"
                        outlined
                        rounded
                        persistent-placeholder
                        clearable
                        placeholder="部分一致"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;トピックの追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="topics"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.start_date`]="{ item }">
                {{ item.start_date | date_format }}
              </template>
              <template v-slot:[`item.end_date`]="{ item }">
                {{ item.end_date | date_format }}
              </template>
              <template v-slot:[`item.content`]="{ item }">
                  {{ item.content | truncate(30) }}
              </template>
              <template v-slot:[`item.url`]="{ item }">
                <a :href="item.url" target="_blank">
                  {{ item.url | truncate(255) }}
                </a>
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="info darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="error darken-2"
                  @click="deleteButtonClickEvent(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="error"
                  @click="deleteButtonClickEvent(item)"
                >
                  削除する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../components/Confirm'
export default {
  name: 'DriverTopicIndex',
  components: {
    Confirm,
  },
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      targetId: null,
      enableTopicDialog: false,
      searchForms: {
        content: null,
      },
      tableHeaders: [
        { value: 'start_date', text: '表示開始日', width: '10%' },
        { value: 'end_date', text: '表示終了日', width: '15%' },
        { value: 'content', text: '内容', width: '30%' },
        { value: 'url', text: 'リンク', width: '35%' },
        { value: 'editable', text: '詳細', width: '10%', align: 'end' },
      ],
      topics: [],
    }
  },
  computed: {
    ...mapState('AdminTopic', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminTopic', [
      'hasResult'
    ]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForms.content = this.searchCondition.content
    this.page = this.pagination.current_page
    this.searchTopic()
  },
  methods: {
    ...mapActions('AdminTopic', {
      fetchTopics: 'index',
      deleteTopic: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    addButtonClickEvent () {
      this.$router.push({ name: 'AdminTopicNew' })
    },
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableTopicDialog = true
    },
    closeTopicDialog () {
      this.enableTopicDialog = false;
    },
    topicCallback (forms) {
      this.closeTopicDialog()
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchTopic()
    },
    editButtonClickEvent (item) {
      this.$router.push({ name: 'AdminTopicEdit', params: { id: item.id } })
    },
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTopic({id: item.id }).then(() =>{
            this.searchTopic ()
          })
        }
      })
    },
    changePage () {
      this.searchTopic()
    },
    searchTopic () {
      let params = { 
        content: this.searchForms.content,
        page: this.page,
      }
      this.fetchTopics(params).then((content) => {
        this.topics = content.topics
        this.total_count = content.pagination.total_count
      })
    }
  }
}
</script>
